export default "__VITE_ASSET__C$kVBonc__"